<template>
  <div class="sm:max-w-4xl mx-auto">
    <resource-index title="Продажи инструментов" endpoint="admin/billing/instruments_sales">
      <template v-slot:table-filters="slotProps">
        <tr class="border-b bg-gray-100">
          <th class="p-3 px-5" scope="col"></th>

          <th class="p-3 px-5" scope="col"></th>

          <th class="p-3 px-5" scope="col"></th>

          <th class="p-3 px-5" scope="col"></th>

          <th colspan="2" class="p-3 px-5" scope="col">
            <date-field
                title="Дата"
                v-model="slotProps.filters.date"
                format="Y-m-d"
                mode="range"
                displayFormat="d.m.Y"
            />
          </th>
          <th colspan="2" class="p-3 px-5" scope="col">
            <select-field
                title="филиал"
                label="name"
                valueName="id"
                :wrap="false"
                :options="selects.branches"
                v-model="slotProps.filters.branch_id"
            />
          </th>
          <th class="p-3 px-5" scope="col"></th>
        </tr>
      </template>
      <template v-slot:table-header>
        <tr class="border-b">
          <th class="text-left p-3 px-5" scope="col">Инструмент</th>
          <th class="text-left p-3 px-5" scope="col">Счет</th>
          <th v-if="false" class="text-left p-3 px-5" scope="col">Продавец</th>
          <th class="text-left p-3 px-5" scope="col">Клиент</th>
          <th class="text-left p-3 px-5" scope="col">Стоимость</th>
          <th class="text-left p-3 px-5" scope="col">Статус</th>
          <th class="text-left p-3 px-5" scope="col">Дата</th>
          <th class="text-left p-3 px-5" scope="col">Филиал</th>
          <th class="text-left p-3 px-5" scope="col">Просмотрено</th>
          <th class="text-left p-3 px-5" scope="col"></th>
        </tr>
      </template>

      <template v-slot:row="slotProps">
        <td class="p-3 px-5">
                <span
                    v-if="slotProps.entry.product.category.rentable"
                >{{ slotProps.entry.product.unique_id }} –</span>
          {{ slotProps.entry.product.name }}
        </td>

        <td class="p-3 px-5">{{ slotProps.entry.amounts.length ? slotProps.entry.amounts[0].account.name : null }}</td>

        <td class="p-3 px-5" v-if="false">{{ slotProps.entry.seller.full_name }}</td>

        <td class="p-3 px-5">{{ slotProps.entry.customer.full_name }}</td>

        <td class="p-3 px-5">
          <span class="badge whitespace-no-wrap badge-success">{{ slotProps.entry.amount }} ₽</span>
        </td>

        <td class="p-3 px-5">
                <span
                    class="badge whitespace-no-wrap badge-success"
                    v-if="slotProps.entry.is_paid"
                >Оплачен</span>
          <span class="badge whitespace-no-wrap badge-indigo" v-else>Ожидание</span>
        </td>

        <td class="p-3 px-5">{{ localTime(slotProps.entry.sold_at) }}</td>
        <td class="p-3 px-5">{{ slotProps.entry.product.branch.name }}</td>
        <td class="p-3 px-5">
          <input
              @click="markAsViews(slotProps.entry)"
              :disabled="slotProps.entry.viewed_at"
              :checked="slotProps.entry.viewed_at"
              type="checkbox"
              class="form-checkbox mt-1"
          />
        </td>

        <td class="p-3 px-5">
          <router-link
              :to="{
                        name: 'admin.instruments_sales.edit',
                        params: {
                            id: slotProps.entry.id
                        }
                    }"
              class="btn btn-info"
          >Посмотреть
          </router-link>
        </td>
      </template>
    </resource-index>
  </div>
</template>

<script>
import ResourceIndex from "@/components/Resource/ResourceIndex";

export default {
  components: {
    ResourceIndex
  },
  data() {
    return {
      selects: {
        branches: []
      }
    };
  },
  methods: {
    markAsViews(order) {
      order.viewed_at = true;

      axios
          .put(`/admin/billing/orders/${order.id}/mark_as_viewed`);
    }
  },
  created() {
    axios.get("/admin/branches/all").then(response => {
      this.selects.branches = response.data.data;
    });
  }
};
</script>
